// components/modals/PasswordModals/ViewPasswordModal.jsx
import React, { useState } from 'react';
import { Modal, Button, Form, InputGroup } from 'react-bootstrap';
import useModalHistory from '../../../hooks/useModalHistory';

const ViewPasswordModal = ({ show, onHide, passwordData }) => {
  const [showPassword, setShowPassword] = useState(false);
  useModalHistory(show, onHide, 'view-password-modal');
  
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="view-password-modal"
      centered
      className="common-modal"
    >
      <Modal.Header closeButton className="custom-header">
        <Modal.Title id="view-password-modal">View Password</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3 row">
            <Form.Label className="col-sm-3 col-form-label">Password Alias:</Form.Label>
            <div className="col-sm-9">
              <Form.Control 
                type="text" 
                id="viewPasswordAlias"
                value={passwordData?.alias || ''} 
                readOnly 
              />
            </div>
          </Form.Group>
          
          <Form.Group className="mb-3 row">
            <Form.Label className="col-sm-3 col-form-label">UserID:</Form.Label>
            <div className="col-sm-9">
              <Form.Control 
                type="text" 
                id="viewUserID"
                value={passwordData?.userID || ''} 
                readOnly 
              />
            </div>
          </Form.Group>
          
          <Form.Group className="mb-3 row">
            <Form.Label className="col-sm-3 col-form-label">Account Number:</Form.Label>
            <div className="col-sm-9">
              <Form.Control 
                type="text" 
                id="viewAccountNumber"
                value={passwordData?.accountNumber || ''} 
                readOnly 
              />
            </div>
          </Form.Group>
          
          <Form.Group className="mb-3 row">
            <Form.Label className="col-sm-3 col-form-label">Contact Number:</Form.Label>
            <div className="col-sm-9">
              <Form.Control 
                type="text" 
                id="viewContactNumber"
                value={passwordData?.contactNumber || ''} 
                readOnly 
              />
            </div>
          </Form.Group>
          
          <Form.Group className="mb-3 row">
            <Form.Label className="col-sm-3 col-form-label">Contact Name:</Form.Label>
            <div className="col-sm-9">
              <Form.Control 
                type="text" 
                id="viewContactName"
                value={passwordData?.contactName || ''} 
                readOnly 
              />
            </div>
          </Form.Group>
          
          <Form.Group className="mb-4">
            <Form.Label className="form-label">Password:</Form.Label>
            <InputGroup className="password-input-group">
              <Form.Control
                type={showPassword ? "text" : "password"}
                id="viewPassword"
                value={passwordData?.password || ''}
                readOnly
                className="password-field"
              />
              <InputGroup.Text 
                className="password-toggle-btn"
                onClick={() => setShowPassword(!showPassword)}
              >
                <i className={`fas fa-${showPassword ? 'eye-slash' : 'eye'}`}></i>
              </InputGroup.Text>
            </InputGroup>
          </Form.Group>
          
          {/* Placeholders for consistent spacing */}
          <div className="form-group row">
            <div className="col-sm-9 offset-sm-3">
              &nbsp;
            </div>
          </div>
          <div className="form-group row">
            <div className="col-sm-9 offset-sm-3">
              &nbsp;
            </div>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default ViewPasswordModal;